<template>
  <div
    class="message-row"
    :class="{
      'user-message-row': !isAI,
      'ai-message-row': isAI,
    }"
  >
    <img
      v-if="isAI"
      src="@/assets/img/lavita.png"
      class="message-avatar-user"
    />

    <el-card
      class="message-bubble"
      :class="{
        'user-message-bubble': !isAI,
        'ai-message-bubble': isAI,
      }"
      shadow="hover"
    >
      <div v-if="aiLoading" class="loading-animation">
        <i class="el-icon-loading"></i>
        <span>Thinking...</span>
      </div>

      <template v-else>
        <div v-if="isAI" class="ai-message-content">
          <vue-markdown :source="message.content" />
          <el-link
            type="danger"
            :underline="false"
            class="report-link"
            @click="$emit('report', message)"
          >
            Report
          </el-link>
        </div>

        <div v-else class="user-message-content">
          <vue-markdown :source="message.content" />
        </div>
      </template>
    </el-card>

    <i v-if="!isAI" class="el-icon-user-solid message-avatar-ai"></i>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";

export default {
  components: {
    VueMarkdown,
  },
  props: {
    message: {
      type: Object,
      default: () => ({}),
    },
    isAI: {
      type: Boolean,
      default: false,
    },
    aiLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
};
</script>

<style scoped>
.message-row {
  display: flex;
  margin-bottom: 16px;
  align-items: flex-start;
}

.user-message-row {
  justify-content: flex-end;
  width: 100%;
}

.ai-message-row {
  justify-content: flex-start;
  width: 100%;
}

.message-bubble {
  max-width: 80%;
  padding: 12px;
  border-radius: 16px;
}

.user-message-bubble {
  background-color: #f2f3f5;
  color: white;
  margin-right: 8px;
  margin-left: 36px;
  border-top-right-radius: 4px;
}

.ai-message-bubble {
  background-color: #f0f0f0;
  margin-left: 4px;
  margin-right: 24px;
  border-top-left-radius: 4px;
}

.message-avatar-user {
  width: 36px;
  height: 36px;
  margin-top: 4px;
}

.message-avatar-ai {
  font-size: 32px;
  color: #34e393;
  margin-top: 4px;
  margin-right: 16px;
}

.loading-animation {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.loading-animation i {
  margin-right: 8px;
  font-size: 20px;
}

.report-link {
  font-size: 12px;
  margin-top: 4px;
  display: inline-block;
}

.ai-message-content >>> p {
  margin-bottom: 8px;
}

.ai-message-content >>> a {
  color: #409eff;
  text-decoration: none;
}

.ai-message-content >>> a:hover {
  text-decoration: underline;
}

.ai-message-content >>> code {
  background-color: #f5f5f5;
  padding: 2px 4px;
  border-radius: 4px;
  font-family: monospace;
}

.ai-message-content >>> pre {
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  overflow-x: auto;
}

.ai-message-content >>> blockquote {
  border-left: 4px solid #ddd;
  padding-left: 16px;
  margin-left: 0;
  color: #777;
}

.ai-message-content >>> ul,
.ai-message-content >>> ol {
  padding-left: 20px;
  margin-bottom: 16px;
}

.ai-message-content >>> h1,
.ai-message-content >>> h2,
.ai-message-content >>> h3,
.ai-message-content >>> h4,
.ai-message-content >>> h5,
.ai-message-content >>> h6 {
  margin-top: 24px;
  margin-bottom: 16px;
  font-weight: bold;
}

.ai-message-content >>> h1 {
  font-size: 2em;
}

.ai-message-content >>> h2 {
  font-size: 1.5em;
}

.ai-message-content >>> h3 {
  font-size: 1.25em;
}

.ai-message-content >>> table {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 16px;
}

.ai-message-content >>> th,
.ai-message-content >>> td {
  border: 1px solid #ddd;
  padding: 8px;
}

.ai-message-content >>> th {
  background-color: #f5f5f5;
}
</style>
